import React from 'react';
import { ClipboardCheckIcon, BarChart2Icon, ScaleIcon, PackageIcon, BeakerIcon, FlaskConicalIcon, ArrowUpIcon, ArrowDownIcon, DatabaseIcon } from 'lucide-react';
export function ProductionOverview() {
  return <div className="bg-gray-50 rounded-lg p-6" data-id="element-706">
      <div className="flex items-center justify-between mb-6" data-id="element-707">
        <div className="flex items-center gap-2" data-id="element-708">
          <ClipboardCheckIcon className="text-[#3498dd]" size={20} data-id="element-709" />
          <h3 className="text-lg font-semibold text-gray-800" data-id="element-710">
            CT:Slurry Prod.
          </h3>
        </div>
        <span className="text-xs bg-blue-50 text-[#3498dd] px-2 py-0.5 rounded" data-id="element-711">
          11.04.25
        </span>
      </div>
      <div className="grid grid-cols-4 gap-4" data-id="element-712">
        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-713">
          <div className="flex items-center justify-between" data-id="element-714">
            <div className="flex items-center gap-2" data-id="element-715">
              <div className="p-2 bg-blue-50 rounded" data-id="element-716">
                <ClipboardCheckIcon className="text-[#3498dd]" size={24} data-id="element-717" />
              </div>
              <div data-id="element-718">
                <h4 className="text-sm font-medium text-gray-700" data-id="element-719">Feststoff</h4>
                <p className="text-xs text-gray-500" data-id="element-720">Aktueller Stand</p>
              </div>
            </div>
            <div className="text-2xl font-bold text-gray-800" data-id="element-721">
              50<span className="text-sm font-normal text-gray-500" data-id="element-722">%</span>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-723">
          <div className="flex items-center justify-between" data-id="element-724">
            <div className="flex items-center gap-2" data-id="element-725">
              <div className="p-2 bg-blue-50 rounded" data-id="element-726">
                <BarChart2Icon className="text-[#3498dd]" size={24} data-id="element-727" />
              </div>
              <div data-id="element-728">
                <h4 className="text-sm font-medium text-gray-700" data-id="element-729">Ansätze</h4>
                <p className="text-xs text-gray-500" data-id="element-730">Gesamt</p>
              </div>
            </div>
            <div className="flex items-center gap-2" data-id="element-731">
              <div className="text-2xl font-bold text-gray-800" data-id="element-732">41</div>
              <div className="flex items-center text-green-600 bg-green-50 px-2 py-1 rounded text-xs" data-id="element-733">
                <ArrowUpIcon size={12} data-id="element-734" />
                <span className="ml-0.5" data-id="element-735">+41</span>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-736">
          <div className="flex items-center justify-between" data-id="element-737">
            <div className="flex items-center gap-2" data-id="element-738">
              <div className="p-2 bg-blue-50 rounded" data-id="element-739">
                <ScaleIcon className="text-[#3498dd]" size={24} data-id="element-740" />
              </div>
              <div data-id="element-741">
                <h4 className="text-sm font-medium text-gray-700" data-id="element-742">Gesamt</h4>
                <p className="text-xs text-gray-500" data-id="element-743">Produktion</p>
              </div>
            </div>
            <div className="flex items-center gap-2" data-id="element-744">
              <div className="text-2xl font-bold text-gray-800" data-id="element-745">
                61,5
                <span className="text-sm font-normal text-gray-500" data-id="element-746">t</span>
              </div>
              <div className="flex items-center text-green-600 bg-green-50 px-2 py-1 rounded text-xs" data-id="element-747">
                <ArrowUpIcon size={12} data-id="element-748" />
                <span className="ml-0.5" data-id="element-749">+61.5t</span>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-750">
          <div className="flex items-center justify-between" data-id="element-751">
            <div className="flex items-center gap-2" data-id="element-752">
              <div className="p-2 bg-blue-50 rounded" data-id="element-753">
                <PackageIcon className="text-[#3498dd]" size={24} data-id="element-754" />
              </div>
              <div data-id="element-755">
                <h4 className="text-sm font-medium text-gray-700" data-id="element-756">Guß</h4>
                <p className="text-xs text-gray-500" data-id="element-757">Aktuell</p>
              </div>
            </div>
            <div className="flex items-center gap-2" data-id="element-758">
              <div className="text-2xl font-bold text-gray-800" data-id="element-759">31</div>
              <div className="flex items-center text-green-600 bg-green-50 px-2 py-1 rounded text-xs" data-id="element-760">
                <ArrowUpIcon size={12} data-id="element-761" />
                <span className="ml-0.5" data-id="element-762">+31</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}